import { testimonials } from '@/mocks/comics';

export default function TestimonialSection() {
  return (
    <section className="w-full py-20 md:py-28 bg-background-50">
      <div className="w-full px-6 md:px-10 max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 text-xs font-medium text-secondary-700 bg-secondary-100 rounded-full mb-4 font-label">
            <span className="w-1.5 h-1.5 rounded-full bg-secondary-500"></span>
            读者口碑
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-heading text-foreground-950">
            漫友们怎么说
          </h2>
        </div>

        {/* Testimonial Cards - Irregular Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {/* Card 1 - Text */}
          <div className="bg-background-100 rounded-xl p-6 md:p-7">
            <div className="flex items-center gap-3 mb-4">
              <img
                src={testimonials[0].avatar}
                alt={testimonials[0].name}
                className="w-10 h-10 rounded-full object-cover"
              />
              <div>
                <div className="text-sm font-semibold text-foreground-900">{testimonials[0].name}</div>
                <div className="text-xs text-foreground-400">{testimonials[0].role}</div>
              </div>
            </div>
            <div className="flex gap-1 mb-3">
              {Array.from({ length: testimonials[0].rating }).map((_, i) => (
                <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
              ))}
            </div>
            <div className="text-5xl font-serif text-foreground-200 leading-none mb-2">&ldquo;</div>
            <p className="text-sm text-foreground-600 leading-relaxed">{testimonials[0].content}</p>
          </div>

          {/* Card 2 - Text */}
          <div className="bg-background-100 rounded-xl p-6 md:p-7">
            <div className="flex items-center gap-3 mb-4">
              <img
                src={testimonials[1].avatar}
                alt={testimonials[1].name}
                className="w-10 h-10 rounded-full object-cover"
              />
              <div>
                <div className="text-sm font-semibold text-foreground-900">{testimonials[1].name}</div>
                <div className="text-xs text-foreground-400">{testimonials[1].role}</div>
              </div>
            </div>
            <div className="flex gap-1 mb-3">
              {Array.from({ length: testimonials[1].rating }).map((_, i) => (
                <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
              ))}
            </div>
            <div className="text-5xl font-serif text-foreground-200 leading-none mb-2">&ldquo;</div>
            <p className="text-sm text-foreground-600 leading-relaxed">{testimonials[1].content}</p>
          </div>

          {/* Card 3 - Image card */}
          <div className="relative rounded-xl overflow-hidden h-64 md:h-auto">
            <img
              src="https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20portrait%20of%20an%20enthusiastic%20anime%20fan%20girl%20reading%20comics%20on%20smartphone%2C%20warm%20cozy%20bedroom%20setting%2C%20soft%20ambient%20lighting%2C%20digital%20art%20style%2C%20clean%20composition%2C%20happy%20expression%2C%20colorful%20atmosphere&width=600&height=800&seq=testimonial-img-01&orientation=portrait"
              alt="忠实读者阅读漫画"
              className="w-full h-full object-cover"
            />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-foreground-950/80 to-transparent p-5">
              <div className="text-sm font-semibold text-background-50">{testimonials[2].name}</div>
              <div className="text-xs text-background-50/70">{testimonials[2].role}</div>
            </div>
          </div>

          {/* Card 4 - Wide image card (spans 2 cols on lg) */}
          <div className="relative rounded-xl overflow-hidden h-56 md:h-64 lg:col-span-2">
            <img
              src="https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20of%20group%20of%20young%20people%20enjoying%20reading%20digital%20comics%20together%20on%20devices%2C%20warm%20cafe%20atmosphere%2C%20cozy%20evening%20vibe%2C%20digital%20art%2C%20clean%20composition%2C%20happy%20expressions&width=1000&height=500&seq=testimonial-img-02&orientation=landscape"
              alt="漫友们一起阅读"
              className="w-full h-full object-cover"
            />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-primary-900/85 to-transparent p-5">
              <div className="text-base font-semibold text-background-50">{testimonials[3].name}</div>
              <div className="text-xs text-background-50/70 mb-1">{testimonials[3].role}</div>
              <p className="text-sm text-background-50/85 leading-relaxed line-clamp-2">{testimonials[3].content}</p>
            </div>
          </div>

          {/* Card 5 - Text */}
          <div className="bg-background-100 rounded-xl p-6 md:p-7">
            <div className="flex items-center gap-3 mb-4">
              <img
                src={testimonials[4].avatar}
                alt={testimonials[4].name}
                className="w-10 h-10 rounded-full object-cover"
              />
              <div>
                <div className="text-sm font-semibold text-foreground-900">{testimonials[4].name}</div>
                <div className="text-xs text-foreground-400">{testimonials[4].role}</div>
              </div>
            </div>
            <div className="flex gap-1 mb-3">
              {Array.from({ length: testimonials[4].rating }).map((_, i) => (
                <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
              ))}
            </div>
            <div className="text-5xl font-serif text-foreground-200 leading-none mb-2">&ldquo;</div>
            <p className="text-sm text-foreground-600 leading-relaxed">{testimonials[4].content}</p>
          </div>
        </div>
      </div>
    </section>
  );
}